import { apiFetch } from './client';

/** The three states the specification names, on every resource that has one. */
export type Visibility = 'PRIVATE' | 'UNLISTED' | 'PUBLIC';

export interface VisibilityChoice {
  value: Visibility;
  label: string;
  description: string;
}

/** Which collection a resource lives in, as the API spells it. */
export type VisibleKind = 'datasets' | 'analyses' | 'dashboards' | 'posts';

/**
 * What each state means — asked of the backend rather than written here, so
 * the words an owner reads before changing who can see their work are the same
 * words the backend enforces.
 */
export async function listVisibilityChoices(): Promise<VisibilityChoice[]> {
  const body = await apiFetch<{ visibility: VisibilityChoice[] }>('/visibility');
  return body.visibility;
}

export async function setVisibility<T>(
  kind: VisibleKind,
  id: string,
  visibility: Visibility,
): Promise<T> {
  return apiFetch<T>(`/${kind}/${id}/visibility`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ visibility }),
  });
}
